/* Baci — banaku i dyqanit brenda faqes.
   Rregullat qe mban: nuk thote "po pershtatet" pa e ditur gjeneraten dhe vitin; te gjeneratat
   me facelift e pyet vete klientin cilin version e ka; nuk perzien versionet; nuk shpik cmim,
   afat, garancion as montim.

   Mesimet e 2 shtatorit, te ngulitura ketu:
   1) Kerkimi behet me kodin BAZE (F20), jo me "F20 Facelift" — katalogu i shkruan titujt me "LCI".
   2) Burimi eshte /search?view=baci (motori i vertete i kerkimit, i paginuar me 50), jo suggest.json.
   3) Produktet pa stok nuk fshihen: kur pjesa ekziston po s'eshte ne stok, Baci e thote ashtu.
   4) BISEDA NUK MBARON KURRE PA NJE VEND KU KLIENTI LE TE DHENAT: edhe kur pjesa s'eshte ne stok,
      edhe kur s'eshte fare ne katalog, Baci hap nje forme te vogel (emri, telefoni, emaili) qe
      krijon nje Customer ne Shopify me taga — restock:<handle> kur pjesa ekziston, kerkese:<slug>
      kur nuk ekziston — dhe detyra e mengjesit i lexon ato.

   Mesimet e 3 shtatorit:
   5) NJE MESAZH MUND TE KETE DY VETURA ("parakolp per G20 dhe W205"). Fjalia ndahet ne pjese
      (dhe / edhe / ose / presje) dhe secila veture merr pergjigjen e vet, me radhe, me vitin e vet.
   6) VETURA E RE = FILLIM I RI. Kur klienti permend nje veture tjeter, viti dhe gjenerata e
      vetures se meparshme NUK trashegohen — me pare "a ke per X5?" pas "G20 2021" pergjigjej
      prape per G20. Trashegohet vetem pjesa ("edhe per X5?" = e njejta pjese, veture tjeter).
   7) Modelet me dy shkronja (A4, X5, Q7) dhe emrat si i thote njeriu (seria 3, 320d, c klasa,
      c220, glc) njihen si fjale te plota. Me pare "x5" nuk njihej fare.
   8) Kodet e perbashketa (B9 = A4/A5/Passat, C8 = A6/A7, 4M = Q7/Q8, E70 = X5/X6) pa modelin
      → Baci pyet cilin, nuk zgjedh vete.
   9) Vetem marka, ose vetem modeli pa gjenerate e pa vit → pyet, nuk kerkon me hamendje.

   Te dhenat: window.BAJRAMI_FIT (fitment.js) · emri: BaciLabel · filtri: BaciFilter.
   theme.js ka nje handler te vjeter per .baci__form — prandaj degjojme ne fazen e kapjes. */
(function () {
  var root = document.querySelector('[data-baci]');
  if (!root) return;
  var FIT = window.BAJRAMI_FIT || {};
  var thread = root.querySelector('[data-baci-thread]');
  var form = root.querySelector('[data-baci-form]');
  var input = root.querySelector('[data-baci-input]');
  var wa = root.getAttribute('data-wa') || '';
  var L = window.BaciLabel || function (m, l) { return m + ' ' + l; };
  /* cars: veturat e radhes se fundit (secila me vitin/gjeneraten e vet); part: pjesa e fundit;
     pendingCode: kodi qe priste modelin (p.sh. "c8" pas pyetjes A6 apo A7) */
  var state = { cars: [], part: null, pendingCode: '' };

  var PARTS = [
    /* 13 shtator: "parakolp" me fjalen e vetme "bumper" i kapte edhe parakolpet e mbrapme —
       nje pyetje per parakolpin para merrte pergjigje me "Rear Bumper". Te 120 titujt e
       katalogut e shkruajne qarte "Front Bumper" ose "Rear Bumper", prandaj ndahen. */
    { k: 'parakolp mbrapa', q: 'rear bumper', paint: 'P1', w: ['rear bumper'], a: ['mbrapakolp', 'parakolp mbrapa', 'parakolpi mbrapa', 'parakolpin mbrapa', 'branik mbrapa', 'braniku mbrapa', 'rear bumper', 'bumper mbrapa', 'heckstossstange'] },
    { k: 'parakolp', q: 'front bumper', paint: 'P1', w: ['front bumper'], a: ['parakolp', 'branik', 'bumper', 'stossstange'] },
    { k: 'body kit', q: 'body kit', paint: 'P2', w: ['body kit'], a: ['body kit', 'bodykit', 'paket'] },
    { k: 'conversion set', q: 'conversion', paint: 'P2', w: ['conversion'], a: ['conversion', 'konversion'] },
    { k: 'kapak motori', q: 'hood', paint: 'P1', w: ['hood', 'bonnet'], a: ['kapak', 'hauba', 'hood'] },
    { k: 'blatnik', q: 'fender', paint: 'P1', w: ['fender'], a: ['blatnik', 'fender'] },
    { k: 'difuzor', q: 'diffuser', paint: 'GB', w: ['diffuser'], a: ['difuzor', 'diffuser'] },
    { k: 'spoiler', q: 'spoiler', paint: 'GB', w: ['spoiler'], a: ['spoiler'] },
    { k: 'front lip', q: 'front lip', paint: 'GB', w: ['lip', 'splitter'], a: ['lip', 'splitter'] },
    { k: 'grill', q: 'grill', paint: 'GB', w: ['grill'], a: ['grill', 'grila', 'maska'] },
    { k: 'pragje', q: 'side skirts', paint: 'GB', w: ['skirt', 'side step'], a: ['pragje', 'skirt', 'side steps'] },
    { k: 'fener', q: 'headlight', paint: 'NO', w: ['headlight'], a: ['fener', 'headlight', 'drita para'] },
    { k: 'stop', q: 'taillight', paint: 'NO', w: ['taillight', 'tail light'], a: ['stop', 'stopa', 'taillight', 'drita mbrapa'] },
    { k: 'auspuh', q: 'exhaust', paint: 'NO', w: ['exhaust', 'tip'], a: ['auspuh', 'exhaust', 'marmit'] }
  ];

  /* Marka dhe modeli si i shkruan njeriu. Emri zyrtar i FIT ("3 Series", "C-Class") njihet gjithmone;
     ketu jane vetem emrat e tjere. Numrat e motorit (320d, c220) tregojne modelin, jo gjeneraten —
     gjeneraten Baci e pyet pastaj. */
  var BRANDS = {
    'Volkswagen': ['volkswagen', 'vw', 'folksvagen', 'folksvagn'],
    'BMW': ['bmw'],
    'Audi': ['audi'],
    'Mercedes-Benz': ['mercedes-benz', 'mercedes', 'merc'],
    'Porsche': ['porsche', 'porshe']
  };
  var ALIAS = {
    '1 Series': ['seria 1', 'serie 1', '1-series', '1er', 'm135', 'm140'],
    '2 Series': ['seria 2', 'serie 2', '2-series', '2er', 'm235', 'm240'],
    '3 Series': ['seria 3', 'serie 3', '3-series', '3er', 'm3', 'm340'],
    '4 Series': ['seria 4', 'serie 4', '4-series', '4er', 'm4'],
    '5 Series': ['seria 5', 'serie 5', '5-series', '5er', 'm5', 'm550'],
    '6 Series': ['seria 6', 'serie 6', '6-series', '6er', 'm6'],
    '7 Series': ['seria 7', 'serie 7', '7-series', '7er', 'm760'],
    '8 Series': ['seria 8', 'serie 8', '8-series', '8er', 'm8', 'm850'],
    'X5': ['x5m'], 'X6': ['x6m'],
    'A1': ['s1'], 'A3': ['s3', 'rs3'], 'A4': ['s4', 'rs4'], 'A5': ['s5', 'rs5'], 'A6': ['s6', 'rs6'],
    'A7': ['s7', 'rs7'], 'A8': ['s8'], 'Q3': ['sq3', 'rsq3', 'rs q3'], 'Q5': ['sq5'], 'Q7': ['sq7'], 'Q8': ['sq8', 'rsq8', 'rs q8'],
    'C-Class': ['c class', 'c klasa', 'c klase', 'klasa c', 'c180', 'c200', 'c220', 'c250', 'c300', 'c350', 'c43', 'c63', 'c 180', 'c 200', 'c 220', 'c 250', 'c 300', 'c 43', 'c 63'],
    'E-Class': ['e class', 'e klasa', 'e klase', 'e200', 'e220', 'e250', 'e300', 'e350', 'e400', 'e450', 'e53', 'e63', 'e 200', 'e 220', 'e 250', 'e 300', 'e 350', 'e 400', 'e 53', 'e 63'],
    'S-Class': ['s class', 's klasa', 's klase', 'klasa s', 's350', 's400', 's450', 's500', 's560', 's580', 's63', 's 350', 's 400', 's 450', 's 500', 's 560', 's 580', 's 63'],
    'A-Class': ['a klasa', 'a klase', 'a180', 'a200', 'a220', 'a250', 'a35', 'a45', 'a 180', 'a 200', 'a 220', 'a 250', 'a 35', 'a 45'],
    'G-Class': ['g class', 'g klasa', 'g klase', 'klasa g', 'g wagon', 'g-wagon', 'g350', 'g400', 'g500', 'g63', 'g 350', 'g 400', 'g 500', 'g 63'],
    'GLC-Class': ['glc'], 'GLE-Class': ['gle'], 'GLS-Class': ['gls'], 'GLA-Class': ['gla'], 'GLB-Class': ['glb'],
    'CLA-Class': ['cla'], 'CLS-Class': ['cls'], 'CLE-Class': ['cle'],
    'Golf': ['gti', 'gtd'], 'Passat': ['pasat'], 'Touareg': ['tuareg'], 'Cayenne': ['kajen']
  };

  function norm(s) {
    return (s || '').toLowerCase().replace(/ë/g, 'e').replace(/ç/g, 'c')
      .replace(/[^a-z0-9\s\.\-]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function say(html, who) {
    var d = document.createElement('div');
    d.className = 'bacimsg bacimsg--' + (who || 'baci');
    d.innerHTML = html;
    thread.appendChild(d);
    thread.scrollTop = thread.scrollHeight;
    return d;
  }
  function typing() { return say('<span class="bacidots"><i></i><i></i><i></i></span>', 'baci'); }
  function chips(list) {
    var h = '<div class="bacichips">';
    for (var i = 0; i < list.length; i++) h += '<button type="button" class="chip bacichip" data-baci-send="' + esc(list[i].send) + '">' + esc(list[i].label) + '</button>';
    return h + '</div>';
  }
  function waLink(text) {
    if (!wa) return '';
    return '<a class="bacilink" target="_blank" rel="noopener" href="https://wa.me/' + wa + '?text=' + encodeURIComponent(text) + '">Vazhdo në WhatsApp</a>';
  }
  /* forma e vogel brenda bisedes: krijon Customer ne Shopify me tagat e dhena */
  function leadForm(tags, why) {
    return '<form class="bacilead" method="post" action="/contact#baci-lead" accept-charset="UTF-8" data-baci-lead>' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="' + esc(tags) + '" data-lead-tags>' +
      '<input type="hidden" name="contact[accepts_marketing]" value="true">' +
      '<p class="bacilead__t">' + why + '</p>' +
      '<div class="bacilead__row"><input type="text" name="contact[first_name]" placeholder="Emri" autocomplete="given-name"><input type="tel" name="contact[phone]" data-lead-phone placeholder="Telefoni (WhatsApp)" autocomplete="tel"></div>' +
      '<div class="bacilead__row"><input type="email" name="contact[email]" placeholder="Email" required autocomplete="email"><button type="submit" class="btn btn--primary">Më njofto</button></div>' +
      '<p class="bacilead__fine muted">Të shkruajmë vetëm për këtë pjesë dhe për oferta të dyqanit. Mund të çregjistrohesh kur të duash.</p>' +
      '</form>';
  }

  /* ---------- leximi i fjalise ---------- */
  function isAlnum(c) { return !!c && /[a-z0-9]/.test(c); }
  /* Te gjitha vendet ku fraza del si fjale e plote. Pas nje kodi qe mbaron me numer lejohet
     shkronje (320d, g20d), pas nje kodi qe mbaron me shkronje lejohet numer (glc220, gle43) —
     po asnjehere e njejta klase: "a4" nuk eshte "a45", "cla" nuk eshte "class", "benz" nuk eshte "benzin". */
  function hits(t, phrase) {
    var out = [], i = 0, lastDigit = /[0-9]/.test(phrase.charAt(phrase.length - 1));
    while ((i = t.indexOf(phrase, i)) > -1) {
      var before = t.charAt(i - 1), rest = t.slice(i + phrase.length), after = rest.charAt(0);
      var okA = !after || !(lastDigit ? /[0-9]/.test(after) : /[a-z]/.test(after));
      /* "golfin", "audin", "pasatit": prapashtesa shqipe pas emrit */
      if (!okA && !lastDigit && /^(i|in|it|n|t|ne|ve|un)(?![a-z0-9])/.test(rest)) okA = true;
      if (!isAlnum(before) && okA) out.push(i);
      i += phrase.length;
    }
    return out;
  }
  /* Numrat e motorit te BMW-se (320d, 118i, 530e, bmw 320): seria = shifra e pare. Pa shkronje
     dhe pa "bmw" para, "320" mund te jete cmim — atehere nuk merret si veture. */
  function bmwNumeric(t) {
    var out = [], re = /(^|[^a-z0-9])(bmw\s+)?([1-8])(\d{2})([a-z]{1,3})?(?![a-z0-9])/g, m;
    while ((m = re.exec(t))) {
      if (!m[2] && !m[5]) continue;
      var start = m.index + m[1].length + (m[2] ? m[2].length : 0);
      out.push({ model: m[3] + ' Series', pos: start, end: start + 3 + (m[5] ? m[5].length : 0) });
    }
    return out;
  }
  /* 13 shtator: shqipja e ndan fjalen — "parakolpi i mbrapme", "parakolp per mbrapa",
     "branik i mbrapem". Aliaset e ngjitura nuk e kapin kete, dhe klienti merrte parakolp para.
     Prandaj: fjale parakolpi + shenje mbrapa kudo ne fjali = parakolp mbrapa. Kjo vlen VETEM
     per parakolpin — "difuzor mbrapa" mbetet difuzor. */
  var BUMP_W = ['parakolp', 'branik', 'bumper', 'stossstange'];
  var REAR_W = ['mbrapa', 'mbrapme', 'mbrapem', 'mbrapmi', 'prapa', 'prapme', 'rear', 'hinten', 'hintere', 'heck'];
  function readPart(t) {
    var hasBump = false, hasRear = false, z;
    for (z = 0; z < BUMP_W.length; z++) if (t.indexOf(BUMP_W[z]) > -1) { hasBump = true; break; }
    if (hasBump) {
      for (z = 0; z < REAR_W.length; z++) if (t.indexOf(REAR_W[z]) > -1) { hasRear = true; break; }
      if (hasRear) for (z = 0; z < PARTS.length; z++) if (PARTS[z].k === 'parakolp mbrapa') return PARTS[z];
    }
    for (var i = 0; i < PARTS.length; i++) for (var j = 0; j < PARTS[i].a.length; j++) if (t.indexOf(PARTS[i].a[j]) > -1) return PARTS[i];
    return null;
  }
  function readYears(t) {
    var out = [], re = /(19[89]\d|20[0-4]\d)/g, m;
    while ((m = re.exec(t))) {
      if (isAlnum(t.charAt(m.index - 1)) && /[0-9]/.test(t.charAt(m.index - 1))) continue;
      if (/[0-9]/.test(t.charAt(m.index + 4))) continue;
      out.push({ v: parseInt(m[1], 10), pos: m.index });
    }
    return out;
  }
  function readFL(t) {
    var out = [], re = /(^|[^a-z])(facelift|face-lift|face lift|fejslift|restyling|lci|fl)(?![a-z0-9])/g, m;
    while ((m = re.exec(t))) out.push({ pos: m.index + m[1].length });
    return out;
  }
  function brandIn(t) {
    for (var b in BRANDS) for (var i = 0; i < BRANDS[b].length; i++) if (hits(t, BRANDS[b][i]).length) return b;
    return '';
  }
  function baseCode(g) { return norm(g).replace(' facelift', ''); }
  /* Kandidatet (marke+model) qe permenden ne kete pjese te fjalise, me pike:
     modeli i thene 3 · kodi i gjenerates 2 (+ gjatesia, qe "golf 7.5" te fitoje mbi "golf 7") · marka 1.5 */
  function detect(t) {
    var cands = [], bn = bmwNumeric(t);
    for (var brand in FIT) {
      var bh = brandIn(t) === brand;
      for (var model in FIT[brand]) {
        var gens = FIT[brand][model], spans = [], mpos = -1, code = '', cpos = -1;
        var names = [norm(model)].concat(ALIAS[model] || []);
        for (var a = 0; a < names.length; a++) {
          var hs = hits(t, names[a]);
          for (var h = 0; h < hs.length; h++) {
            spans.push([hs[h], hs[h] + names[a].length]);
            if (mpos < 0 || hs[h] < mpos) mpos = hs[h];
          }
        }
        if (brand === 'BMW') for (var b = 0; b < bn.length; b++) if (bn[b].model === model) {
          spans.push([bn[b].pos, bn[b].end]);
          if (mpos < 0 || bn[b].pos < mpos) mpos = bn[b].pos;
        }
        var clen = 0;
        for (var i = 0; i < gens.length; i++) {
          var cb = baseCode(gens[i].g), forms = [cb, cb.replace(/ /g, '')];
          if (cb.length < 2) continue;
          if (cb.indexOf(' ') > -1) forms.push(cb.replace(/^([a-z]+) /, '$1in '), cb.replace(/^([a-z]+) /, '$1i '), cb.replace(/^([a-z]+) /, '$1it '));
          for (var f = 0; f < forms.length; f++) {
            var hc = hits(t, forms[f]);
            if (hc.length && cb.length > code.length) { code = cb; cpos = hc[0]; clen = forms[f].length; }
          }
        }
        if (mpos < 0 && !code) continue;
        if (code) spans.push([cpos, cpos + clen]);
        var pos = mpos > -1 && (cpos < 0 || mpos < cpos) ? mpos : cpos;
        cands.push({ brand: brand, model: model, gens: gens, code: code, named: mpos > -1, pos: pos, spans: spans,
          score: (mpos > -1 ? 3 : 0) + (code ? 2 + code.length / 10 : 0) + (bh ? 1.5 : 0) });
      }
    }
    cands.sort(function (a, b) { return b.score - a.score || a.pos - b.pos; });
    return cands;
  }
  function blank(t, spans) {
    var arr = t.split('');
    for (var i = 0; i < spans.length; i++) for (var j = spans[i][0]; j < spans[i][1]; j++) arr[j] = ' ';
    return arr.join('');
  }
  /* Veturat ne nje pjese te fjalise. Merr me te mireen, ia fshin fjalet, kerkon prape — keshtu
     "a4 x5 parakolp" jep dy vetura edhe pa "dhe". Kod i perbashket pa model → ambiguous. */
  function carsIn(t) {
    var out = [], amb = null, text = t, n = 0;
    while (n++ < 3) {
      var c = detect(text);
      if (!c.length) break;
      var top = c[0];
      if (!top.named && top.code) {
        var same = [top];
        for (var i = 1; i < c.length; i++) if (c[i].score === top.score && c[i].code === top.code && !c[i].named) same.push(c[i]);
        if (same.length > 1) { same.sort(function (a, b) { return a.model < b.model ? -1 : 1; }); amb = same; break; }
      }
      out.push(top);
      text = blank(text, top.spans);
    }
    out.sort(function (a, b) { return a.pos - b.pos; });
    return { cars: out, amb: amb };
  }
  function nearest(cars, pos) {
    var best = null, bd = 1e9;
    for (var i = 0; i < cars.length; i++) { var d = Math.abs(cars[i].pos - pos); if (d < bd) { bd = d; best = cars[i]; } }
    return best;
  }
  function unit(c, year, fl, part) {
    return { brand: c.brand, model: c.model, gens: c.gens, code: c.code, said: !!c.code, year: year || 0, fl: !!fl, part: part || null, gen: '' };
  }
  function key(u) { return u.brand + '|' + u.model + '|' + u.code + '|' + (u.fl ? 1 : 0) + '|' + u.year; }
  /* Fjalia e plote → lista e veturave, secila me vitin, versionin dhe pjesen e vet. */
  var SEP = /\s*(?:[,;\/+&|]|\n|\bedhe\b|\bdhe\b|\bose\b|\bapo\b|\bplus\b)\s*/;
  function parse(raw) {
    var low = (raw || '').toLowerCase().replace(/ë/g, 'e').replace(/ç/g, 'c').replace(/(\d),(\d)/g, '$1.$2');
    var whole = norm(low);
    var gpart = readPart(whole);
    var pieces = low.split(SEP), units = [], amb = [], seen = {}, brandOnly = '';
    for (var p = 0; p < pieces.length; p++) {
      var t = norm(pieces[p]);
      if (!t) continue;
      var r = carsIn(t), part = readPart(t) || gpart;
      var years = readYears(t), fls = readFL(t), i, u;
      for (i = 0; i < r.cars.length; i++) r.cars[i].u = unit(r.cars[i], 0, false, part);
      for (i = 0; i < years.length; i++) { u = nearest(r.cars, years[i].pos); if (u && !u.u.year) u.u.year = years[i].v; }
      for (i = 0; i < fls.length; i++) { u = nearest(r.cars, fls[i].pos); if (u) u.u.fl = true; }
      for (i = 0; i < r.cars.length; i++) { var k = key(r.cars[i].u); if (!seen[k]) { seen[k] = 1; units.push(r.cars[i].u); } }
      if (r.amb) amb.push({ list: r.amb, part: part, year: years.length ? years[0].v : 0, fl: fls.length > 0 });
      if (!r.cars.length && !r.amb) brandOnly = brandOnly || brandIn(t);
    }
    return { units: units, amb: amb, brandOnly: brandOnly, part: gpart, whole: whole };
  }

  /* ---------- gjenerata ---------- */
  function variants(car) {
    var out = [];
    if (!car || !car.code) return out;
    for (var i = 0; i < car.gens.length; i++) if (baseCode(car.gens[i].g) === car.code) out.push(car.gens[i]);
    return out;
  }
  function fits(v, year) { return year >= (v.f || 0) && year <= (v.t || 9999); }
  function pickByYear(vs, year) {
    var best = null;
    for (var i = 0; i < vs.length; i++) if (fits(vs[i], year) && (!best || (vs[i].n || 0) > (best.n || 0))) best = vs[i];
    return best;
  }
  function topGens(gens, n) {
    var s = gens.slice().sort(function (a, b) { return (b.n || 0) - (a.n || 0); });
    return s.slice(0, n);
  }
  function genChips(car, gens) {
    var out = [];
    for (var i = 0; i < gens.length; i++) out.push({ label: gens[i].l, send: car.brand + ' ' + car.model + ' ' + gens[i].g + ' ' + (gens[i].f || '') });
    return out;
  }
  function carName(car, chosen) {
    var label = chosen ? chosen.l : (car.code ? car.code.toUpperCase() : car.model);
    return L(car.model, label);
  }
  /* emri i nje veture te ruajtur: me etiketen e gjenerates kur e dime ("Golf 7 (2012–2017)") */
  function carLabel(c) {
    if (c.gen) for (var i = 0; i < c.gens.length; i++) if (c.gens[i].g === c.gen) return L(c.model, c.gens[i].l);
    return c.code ? L(c.model, c.code.toUpperCase()) : c.model;
  }

  /* ---------- kerkimi ---------- */
  function search(q, cb) {
    fetch('/search?view=baci&type=product&q=' + encodeURIComponent(q), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { cb((d && d.products) || []); })
      .catch(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
          .then(function (r) { return r.json(); })
          .then(function (d) { cb((d && d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () { cb([]); });
      });
  }
  /* Kur kodi eshte i perbashket (B9 = A4/A5), titulli duhet ta permbaje modelin — po vetem nese
     ndonje titull e permban fare; ndryshe lista mbetet si eshte. */
  function modelForms(car) {
    var m = norm(car.model), forms = [m];
    if (m.indexOf('-class') > -1) forms.push(m.replace('-class', ' class'), m.replace('-class', ' klasse'), m.replace('-class', '-klasse'));
    if (/ series$/.test(m)) forms.push(m.replace(' series', 'er'), m.replace(' series', '-series'), m.replace(' series', ' serie'));
    return forms.concat(ALIAS[car.model] || []);
  }
  function byModel(list, car) {
    var forms = modelForms(car), out = [];
    for (var i = 0; i < list.length; i++) {
      var n = norm(list[i].title);
      for (var f = 0; f < forms.length; f++) if (hits(n, forms[f]).length) { out.push(list[i]); break; }
    }
    return out.length ? out : list;
  }
  function stockFirst(list) {
    var yes = [], no = [];
    for (var i = 0; i < list.length; i++) (list[i].available === false ? no : yes).push(list[i]);
    return yes.concat(no);
  }
  function allOut(list) {
    for (var i = 0; i < list.length; i++) if (list[i].available !== false) return false;
    return list.length > 0;
  }
  function productHtml(p) {
    var src = p.image || (p.featured_image && p.featured_image.url) || '';
    var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '';
    var price = p.price ? '<span class="price">' + esc(p.price) + '</span>' : '';
    var out = p.available === false ? ' <span class="muted" style="font-size:12px">· s’ka në stok</span>' : '';
    return '<a class="bacip" href="' + esc(p.url) + '">' + img + '<span class="bacip__t">' + esc(p.title) + out + '</span>' + price + '</a>';
  }

  function policyLine(part) {
    if (!part) return 'Përshtatjen e konfirmojmë ne para se ta porosisim. Nëse nuk përshtatet, e ndërrojmë falas — po afati është 48 orë nga marrja.';
    if (part.paint === 'GB') return 'Kjo vjen e gatshme në black gloss — pa lyerje, pa pritje, pa kosto shtesë. Nëse nuk përshtatet, e ndërrojmë falas brenda 48 orëve nga marrja.';
    if (part.paint === 'P1' || part.paint === 'P2') return 'Këtë mund ta marrësh të lyer në ngjyrën e veturës: na duhet kodi i ngjyrës (letra në kornizën e derës së djathtë të përparme) dhe 3–6 foto në dritë natyrale. Lyerja faturohet veç: 50% para se të fillojmë, pjesa tjetër kur e merr — dhe pas lyerjes nuk ka kthim as ndërrim, prandaj përshtatjen dhe kodin i konfirmojmë në telefon para se të nisë puna.';
    return 'Përshtatjen e konfirmojmë ne para se ta porosisim. Kthimi dhe ndërrimi: 48 orë nga marrja.';
  }

  /* ---------- pyetjet ---------- */
  function askVersion(car, vs, why) {
    var a = vs[0], b = vs[1];
    say((why || 'Për ' + esc(car.brand) + ' ' + esc(car.model) + ' ka dy versione të kësaj gjenerate, dhe pjesët e parë nuk janë të njëjta:') +
      '<br><b>' + esc(a.l) + '</b> dhe <b>' + esc(b.l) + '</b>.<br>Cilin e ke? Ma thuaj vitin e prodhimit.' +
      chips(genChips(car, [a, b])));
  }
  function askGen(car) {
    var top = topGens(car.gens, 4);
    say('Për <b>' + esc(car.brand) + ' ' + esc(car.model) + '</b> kemi pjesë për ' + car.gens.length + ' gjenerata, dhe nuk i hyjnë njëra-tjetrës. Cilën e ke? Ma thuaj vitin e prodhimit ose kodin' +
      (car.gens.length > top.length ? ' — këto janë më të kërkuarat:' : ':') + chips(genChips(car, top)));
  }
  function askModel(brand) {
    var models = [], m;
    for (m in FIT[brand]) {
      var tot = 0;
      for (var i = 0; i < FIT[brand][m].length; i++) tot += FIT[brand][m][i].n || 0;
      models.push({ m: m, n: tot });
    }
    models.sort(function (a, b) { return b.n - a.n; });
    var cs = [];
    for (var j = 0; j < Math.min(6, models.length); j++) cs.push({ label: models[j].m, send: brand + ' ' + models[j].m });
    say('<b>' + esc(brand) + '</b> — cilin model e ke? Shkruaje bashkë me vitin (p.sh. „' + esc(models[0].m) + ' 2019“) ose zgjidhe:' + chips(cs));
  }
  function askWhichModel(a) {
    var cs = [], names = [];
    for (var i = 0; i < a.list.length; i++) {
      var c = a.list[i];
      names.push(c.model + ' ' + c.code.toUpperCase());
      cs.push({ label: c.brand + ' ' + c.model + ' ' + c.code.toUpperCase(), send: c.brand + ' ' + c.model + ' ' + c.code.toUpperCase() + (a.fl ? ' facelift' : '') + (a.year ? ' ' + a.year : '') });
    }
    state.pendingCode = a.list[0].code;
    say('Kodin <b>' + esc(a.list[0].code.toUpperCase()) + '</b> e kanë ' + (a.list.length === 2 ? 'dy' : a.list.length) + ' modele — ' + esc(names.join(', ')) + ' — dhe pjesët nuk janë të njëjta. Cilin e ke?' + chips(cs));
  }
  function askWhichCar(cars, year, fl) {
    var cs = [], names = [];
    for (var i = 0; i < cars.length; i++) {
      var c = cars[i], nm = carLabel(c);
      names.push(nm);
      cs.push({ label: nm + (year ? ' ' + year : ''), send: c.brand + ' ' + c.model + (c.code ? ' ' + c.code.toUpperCase() : '') + (fl ? ' facelift' : '') + (year ? ' ' + year : '') });
    }
    say('Për cilën veturë e ke fjalën — ' + esc(names.join(' apo ')) + '?' + chips(cs));
  }

  /* ---------- pergjigja per nje veture ---------- */
  function answerUnit(car, done) {
    var part = car.part, year = car.year, chosen = null, k;

    /* vetem modeli, pa kod: viti e zgjedh gjeneraten; pa vit, pyet */
    if (!car.code) {
      if (year) chosen = pickByYear(car.gens, year);
      if (!chosen && year) {
        say('Për <b>' + esc(car.brand) + ' ' + esc(car.model) + ' ' + year + '</b> nuk kemi asgjë në katalog — gjeneratat që i mbulojmë:' + chips(genChips(car, topGens(car.gens, 4))) +
          '<p class="bacinext">' + waLink('Përshendetje, kërkoj ' + (part ? part.k : 'pjesë') + ' për ' + car.brand + ' ' + car.model + ' ' + year) + '</p>');
        return done();
      }
      if (!chosen && car.gens.length > 1) { askGen(car); return done(); }
      if (!chosen) chosen = car.gens[0];
      car.code = baseCode(chosen.g);
      chosen = null;
    }

    var vs = variants(car), two = vs.length > 1;
    if (two) {
      if (car.fl) {
        for (k = 0; k < vs.length; k++) if (norm(vs[k].g).indexOf('facelift') > -1) chosen = vs[k];
      } else if (year) {
        chosen = pickByYear(vs, year);
        if (chosen && fits(vs[0], year) && fits(vs[1], year)) {
          askVersion(car, vs, 'Viti <b>' + year + '</b> te ' + esc(car.brand) + ' ' + esc(car.model) + ' bie në kufirin e dy versioneve, dhe pjesët e parë nuk janë të njëjta:');
          return done();
        }
      } else { askVersion(car, vs); return done(); }
    } else if (vs.length === 1) {
      chosen = vs[0];
      if (year && !fits(chosen, year)) chosen = null;
    }
    if (!chosen && year) {
      /* kodi dhe viti nuk perputhen: "G20 2010" — G20 fillon me 2019, 2010 bie te E90 */
      var other = pickByYear(car.gens, year), opts = vs.slice(), span = [];
      for (k = 0; k < vs.length; k++) span.push(vs[k].l.replace(/^.*\(|\)$/g, ''));
      if (other) opts.push(other);
      say('<b>' + esc(car.code.toUpperCase()) + '</b> është ' + esc(span.join(' / ')) + ', kurse viti <b>' + year + '</b>' +
        (other ? ' bie te <b>' + esc(other.l) + '</b>' : ' nuk i takon asnjë gjenerate që e mbulojmë') + '. Cilën e ke?' + chips(genChips(car, opts)));
      return done();
    }
    if (!chosen) chosen = vs[0] || null;
    if (chosen) car.gen = chosen.g;

    var name = carName(car, chosen);
    var what = (part ? part.k : 'pjesë') + ' për ' + car.brand + ' ' + name;
    var base = car.code ? car.code.toUpperCase() : '';
    var qPart = [car.brand, car.model, base, part ? part.q : ''].join(' ').replace(/\s+/g, ' ').trim();
    var qCar = [car.brand, car.model, base].join(' ').replace(/\s+/g, ' ').trim();
    var F = window.BaciFilter || function (x) { return x; };

    /* 13 shtator: pjesa qe kerkohet nuk eshte te kjo gjenerate, po ekziston te MOTRA e saj
       (para-facelift kunder facelift, ose hapi .5: Golf 7 / Golf 7.5). Me mire ta themi hapur
       cila gjenerate eshte dhe te kerkojme vitin e sakte dhe foton, sesa ta zevendesojme me
       nje pjese tjeter fare. Kufiri: VETEM brenda te njejtes familje — Golf 7.5 dhe Golf 8
       i mbivendosen vitet po jane platforma te ndryshme, aty s'ka cka te konfirmohet. */
    function sameFamily(a, b) {
      var x = baseCode(a.g), y = baseCode(b.g);
      if (!x || !y) return false;
      if (x === y) return true;
      return x.replace(/\.5$/, '') === y.replace(/\.5$/, '');
    }
    function genGap(a, b) {
      var af = a.f || 0, at = a.t || 9999, bf = b.f || 0, bt = b.t || 9999;
      if (af <= bt && bf <= at) return 0;
      return bf > at ? bf - at : af - bt;
    }
    function nearGen(ps) {
      if (!part || !chosen) return null;
      var cands = [], i;
      for (i = 0; i < car.gens.length; i++) {
        var v = car.gens[i];
        if (v.g === chosen.g) continue;
        if (!sameFamily(chosen, v)) continue;
        if (genGap(chosen, v) > 2) continue;
        cands.push({ v: v, gap: genGap(chosen, v) });
      }
      cands.sort(function (a, b) { return a.gap - b.gap; });
      for (i = 0; i < cands.length; i++) {
        var g = cands[i].v;
        var hit = F(ps, g, baseCode(g.g), false, part.w);
        if (hit.length) { hit = byModel(hit, car); if (hit.length) return { list: hit, label: L(car.model, g.l) }; }
      }
      return null;
    }

    search(qPart, function (ps) {
      var strict = byModel(F(ps, chosen, car.code, two, part ? part.w : null), car);
      if (strict.length) return render(stockFirst(strict), false);
      var nb = nearGen(ps);
      if (nb) return render(stockFirst(nb.list), false, nb.label);
      search(qCar, function (ps2) {
        var strict2 = byModel(F(ps2, chosen, car.code, two, part ? part.w : null), car);
        if (strict2.length) return render(stockFirst(strict2), false);
        var loose = byModel(F(ps2, chosen, car.code, two, null), car);
        render(stockFirst(loose), true);
      });
    });

    function render(list, widened, nearLabel) {
      if (!list.length) {
        say('<b>' + esc(what) + '</b> nuk e kemi në faqe tash — dhe nuk po të tregoj pjesë të versionit tjetër, sepse nuk të hyjnë. Po e marrim si kërkesë: lëre kontaktin dhe të përgjigjemi a e sjellim dhe kur.' +
          leadForm('kerkese, kerkese:' + slug(what) + ', source:baci', 'Të shkruajmë për <b>' + esc(what) + '</b>:') +
          '<p class="bacinext">Ose ' + waLink('Përshendetje, kërkoj ' + what) + ' tash.</p>');
        return done();
      }
      var head, tail = '';
      if (nearLabel) {
        head = '<b>' + esc(part.k) + '</b> për <b>' + esc(name) + '</b> nuk e kemi. E kemi në katalog për <b>' + esc(nearLabel) +
          '</b> — a të hyn duhet konfirmuar, prandaj ma thuaj vitin e saktë dhe ma dërgo një foto të pjesës që ke tash para se ta porosisim:';
        if (allOut(list)) head += '<br><b>Kujdes:</b> as këto nuk janë tash në stok — porositen.';
        tail = leadForm('kerkese, kerkese:' + slug(what) + ', source:baci', 'Ose lëre kontaktin dhe ta konfirmojmë ne përshtatjen:') +
          '<p class="bacinext">Ose ' + waLink('Përshendetje, kërkoj ' + what + ' — a më hyn ai i ' + nearLabel + '?') + '</p>';
      } else if (!widened && part && allOut(list)) {
        var p0 = list[0];
        head = '<b>' + esc(part.k) + '</b> për <b>' + esc(name) + '</b> e kemi në katalog, po tash <b>nuk është në stok</b> — porositet:';
        tail = leadForm('restock, restock:' + (p0.handle || slug(p0.title)) + (p0.variant ? ', variant:' + p0.variant : '') + ', source:baci', 'Lëre kontaktin dhe të njoftojmë vetë sapo të vijë:') +
          '<p class="bacinext">Ose ' + waLink('Përshendetje, kur vjen ' + what + '?') + ' për ditën e saktë.</p>';
      } else if (widened && part) {
        /* 13 shtator: kjo fjali thoshte "Këto janë për të njëjtin version të veturës" mbi pjesë
           qe shpesh nuk ishin as e njejta pjese, as e njejta gjenerate (parakolp G20 Facelift →
           body kit G20 2019–2023). Tash thuhet hapur se jane pjese TE TJERA, dhe se pershtatja
           e tyre konfirmohet — asnje pretendim qe nuk e mbajme dot. */
        head = 'Pikërisht <b>' + esc(part.k) + '</b> për <b>' + esc(name) + '</b> nuk po e gjej në faqe. ' +
          'Këto janë <b>pjesë të tjera</b> që i kemi për këtë veturë, dhe përshtatjen e konfirmojmë para porosisë:';
        /* Body kit-i e permban edhe parakolpin — mos e lere klientin ta besoje se s'e kemi fare. */
        if (/parakolp|bumper/i.test(part.k)) {
          for (var bk = 0; bk < list.length; bk++) {
            if (/body kit|conversion/i.test(list[bk].title || '')) {
              head += '<br>Body kit-i e <b>përfshin edhe parakolpin</b> — nëse të hyn si set, e ke edhe pjesën që kërkove.';
              break;
            }
          }
        }
        tail = leadForm('kerkese, kerkese:' + slug(what) + ', source:baci', 'Nëse e do pikërisht <b>' + esc(part.k) + '</b>, lëre kontaktin dhe të përgjigjemi a e sjellim:') +
          '<p class="bacinext">Ose ' + waLink('Përshendetje, kërkoj ' + what) + '.</p>';
      } else if (part) {
        head = '<b>' + esc(part.k) + '</b> për <b>' + esc(name) + '</b> — kjo kemi:';
      } else {
        head = 'Për <b>' + esc(name) + '</b> kemi këto:';
      }
      var body = '<div class="baciprods">';
      for (var i = 0; i < Math.min(3, list.length); i++) body += productHtml(list[i]);
      body += '</div>';
      if (!tail) tail = '<p class="bacinext">Nëse ma thua edhe versionin (M Packet, R-Line, AMG Line) ose ma dërgon një foto të pjesës që ke tash, e mbyllim pa gabim. ' + waLink('Përshendetje, ' + what) + '</p>';
      say(head + body + '<p class="bacipolicy">' + policyLine(part) + '</p>' + tail);
      done();
    }
  }

  /* ---------- pergjigja per mesazhin ---------- */
  function answer(raw) {
    /* 6 shtator: pyetjet e sherbimit (orar, kontakt, ...) i pergjigjet baci-service.js. Nese mesazhi ka
       edhe veture, pjesa pergjigjet e para dhe sherbimi shtohet ne fund (sv.after). */
    var sv = null;
    try { sv = window.BaciService ? window.BaciService(raw, state) : null; } catch (e0) { sv = null; }
    if (typeof sv === 'string') sv = { html: sv, after: false };
    if (sv && sv.html && !sv.after) {
      var th0 = typing();
      setTimeout(function () { th0.remove(); say(sv.html); }, 320);
      return;
    }
    var r = parse(raw), units = r.units, i;
    if (r.part) state.part = r.part;

    var th = typing();
    setTimeout(function () {
      th.remove();

      if (!units.length && !r.amb.length) {
        if (r.brandOnly) { state.cars = []; askModel(r.brandOnly); if (sv && sv.after) say(sv.html); return; }
        /* asnje veture ne mesazh: vazhdim i bisedes per veturat e radhes se fundit */
        var ys = readYears(r.whole), year = ys.length ? ys[0].v : 0, fl = readFL(r.whole).length > 0, part = readPart(r.whole);
        if (!state.cars.length) {
          say('Ma thuaj veturën dhe pjesën — p.sh. „parakolp para për G20 2021“ ose „difuzor për W205“. Nga modeli dhe viti e di saktësisht cila pjesë të hyn.');
          return;
        }
        if (state.cars.length > 1 && (year || fl) ) { askWhichCar(state.cars, year, fl); return; }
        if (!part && !year && !fl) {
          var names = state.cars.map(function (c) { return c.brand + ' ' + carLabel(c); }).join(', ');
          say('Për <b>' + esc(names) + '</b> — cilën pjesë e kërkon? P.sh. parakolp, difuzor, grill, spoiler, pragje, fener, auspuh. ' +
            (state.cars.length > 1 ? 'Ma thuaj edhe për cilën veturë. ' : '') + waLink('Përshendetje, kërkoj pjesë për ' + names));
          return;
        }
        for (i = 0; i < state.cars.length; i++) {
          var c = state.cars[i], keep = c.said || !year;
          units.push({ brand: c.brand, model: c.model, gens: c.gens, code: keep ? c.code : '', said: c.said, year: year || c.year, fl: fl || c.fl, part: part || c.part || state.part, gen: '' });
        }
      }

      /* modeli pa kod, po kodi u tha ne mesazhin e meparshem ("A6 apo A7?" → "a6") */
      for (i = 0; i < units.length; i++) {
        var u = units[i];
        if (!u.part) u.part = state.part;
        if (!u.code && state.pendingCode) {
          for (var g = 0; g < u.gens.length; g++) if (baseCode(u.gens[g].g) === state.pendingCode) u.code = state.pendingCode;
        }
      }
      state.pendingCode = '';
      if (units.length) state.cars = units;

      if (units.length > 1) say((units.length === 2 ? 'Dy' : units.length === 3 ? 'Tri' : units.length) + ' vetura — po t’i marr me radhë.');
      var n = 0;
      (function next() {
        if (n < units.length) { var u = units[n++]; setTimeout(function () { answerUnit(u, next); }, n > 1 ? 260 : 0); return; }
        for (var a = 0; a < r.amb.length; a++) askWhichModel(r.amb[a]);
        if (sv && sv.after) say(sv.html);
      })();
    }, 320);
  }

  function ask(v) { if (!v) return; say(esc(v), 'me'); answer(v); }
  window.BaciAsk = ask;
  window.BaciParse = parse;
  window.BACI_READY = true;

  if (/customer_posted=true/.test(location.search)) {
    say('<b>U regjistrua.</b> Të shkruajmë sapo të kemi përgjigje për pjesën — me email, dhe në WhatsApp nëse ke lënë numrin.');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var v = (input.value || '').trim();
    input.value = '';
    ask(v);
  }, true);

  root.addEventListener('submit', function (e) {
    var lf = e.target.closest('[data-baci-lead]');
    if (!lf) return;
    var p = lf.querySelector('[data-lead-phone]'), tg = lf.querySelector('[data-lead-tags]');
    if (p && tg && p.value.trim()) tg.value = tg.value + ', tel:' + p.value.replace(/[^0-9+]/g, '');
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-baci-send], [data-baci-fill]');
    if (!b || !root.contains(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ask(b.getAttribute('data-baci-send') || b.getAttribute('data-baci-fill'));
  }, true);
})();
